import {  Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./component/Login";
import ForgotPassword from "./component/ForgotPassword";
import DriverList from "./component/DriverList";
import AddDriverForm from "./component/AddDriver";
import DriverDetails from "./component/DriverDetails";
import HomePage from "./Pages/HomePage";
import Profile from "./Pages/Profile";
import useAutoLogout from "./hooks/useAutoLogout";
import PrintRoute from "./components/PrintRoute";
import SchoolList from "./component/SchoolList";

import BusDetails from "./Pages/busManagementScreens/BusDetails";
import BusManagement from "./Pages/busManagementScreens/BusManagement";
import AddBus from "./Pages/busManagementScreens/AddBus";
import ChangePassword from "./Pages/ChangePassword";
import BusView from "./Pages/busManagementScreens/BusView";
import SchoolView from "./component/SchoolView";
import AddUsers from "./Pages/AddUsers";
import UsersTable from "./Pages/Users";
import PoliceStationView from "./component/PoliceStationView";


function App() {
  useAutoLogout()
  return (
    
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Protected routes inside Layout */}
        <Route path="/" element={<Layout />}>
          {/* Default redirect → /home */}
          <Route index element={<Navigate to="/login" replace />} />

          {/* Home and other app routes */}
          <Route path="home" element={<HomePage />} />
          <Route path="buses" element={<BusManagement />} />
          <Route path="/buses/add" element={<AddBus />} />
          <Route path="/buses/:id" element={<BusDetails />} />
          <Route path="drivers" element={<DriverList />} />
          <Route path="schools" element={<SchoolList />} />
          <Route path="/bus/view" element={<BusView />} />
          <Route path="/school/view" element={<SchoolView />} />
          <Route path="/policestation/view" element={<PoliceStationView />} />
          <Route path="/print" element={<PrintRoute />} />
          <Route path="conductors" element={<Navigate to="/drivers" replace />} />
          <Route path="vehicles" element={<Navigate to="/buses" replace />} />
          <Route path="drivers/:id" element={<DriverDetails />} />
          <Route path="/drivers/add" element={<AddDriverForm mode="add" />} />
          <Route path="/drivers/edit/:driverId" element={<AddDriverForm mode="edit" />} />
            <Route path="/users" element={<UsersTable/>} />
                    <Route path="/profile" element={<Profile/>} />
                    <Route path="/AddUsers" element={<AddUsers/>} />
                    <Route path="/changePassword" element={<ChangePassword/>} />


          {/* Forms */}
          <Route path="add-driver" element={<AddDriverForm />} />
          <Route path="add-conductor" element={<Navigate to="/add-driver" replace />} />
        </Route>

        {/* Dashboard (if needed outside layout) */}
        <Route path="/dashboard" element={<Navigate to="/home" replace />} />

        {/* Catch-all redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    
  );
}

export default App;
